import ReloadButton from 'CMFW/button/ReloadButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import { booleanCheckRenderer } from 'CMFW/grid/cellRenderers/booleanCheck';
import { IFields } from 'CMFW/grid/fields';
import Grid from 'CMFW/grid/Grid';
import ItemLayout from 'CMFW/layout/ItemLayout';
import { LoadingItem } from 'CMFW/layout/Loading';
import { ContainerLeft, ContainerLeftFooter, ContainerRight, ModuleContainer } from 'components/common/styles';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import HanziModel from 'models/HanziModel';
import React, { useMemo } from 'react';
import HanziCardItem from './HanziCardItem';
import { IGridData } from 'types/models';
import { ComponentRow, GF_ID_BASE, numFromCardId } from './types';
import HanziComponentNames from './HanziComponentNames';

const cellRenderers = {
  [IFields.complete]: booleanCheckRenderer,
  [IFields.inStandard]: booleanCheckRenderer,
  [IFields.bareStroke]: booleanCheckRenderer,
};

/** The 514 components of GF 0014-2009; a row opens the card of the component when it has one. */
const HanziComponentsTab: React.FC = () => {
  const forceRender = useForceRender();
  const model = useMemo(() => new HanziModel({ render: forceRender, mode: 'components' }), [forceRender]);

  const handleRowClick = (data: IGridData) => {
    const row = data as ComponentRow;
    // a component with no card still has names to edit: it is opened by its GF number
    model.loadItemEdit(row.cardId ? numFromCardId(row.cardId) : GF_ID_BASE + row.seq);
  };

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={model}>
        <Split widthLeft={620}>
          <ContainerLeft>
            <Grid cellRenderers={cellRenderers} handleRowClick={handleRowClick} />
            <ContainerLeftFooter>
              <ReloadButton />
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            <ItemLayout>
              <HanziComponentNames />
              <HanziCardItem />
            </ItemLayout>
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default HanziComponentsTab;
